import api from 'services/api';

const ixcSourceService = {
  async list() {
    const response = await api.get('/admin/ixc-sources');
    return response.data;
  },

  async create(data) {
    const response = await api.post('/admin/ixc-sources', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.put(`/admin/ixc-sources/${id}`, data);
    return response.data;
  },

  async toggle(id) {
    const response = await api.patch(`/admin/ixc-sources/${id}/toggle`);
    return response.data;
  },

  async test(id) {
    const response = await api.post(`/admin/ixc-sources/${id}/test`);
    return response.data;
  },
};

export default ixcSourceService;
